"use client";

import { useState, useRef, useEffect, useCallback } from "react";

export default function DocumentIcon({ name, onClick, style, className = "",src="https://framerusercontent.com/images/RHAvQg2vnbtBKRG0ph3erPEvgb0.png?width=236&height=236" }) {
  const [position, setPosition] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const dragOffset = useRef({ x: 0, y: 0 });
  const elementRef = useRef(null);
  const didDrag = useRef(false);

  const handleMouseDown = useCallback((e) => {
    if (e.button !== 0) return;
    e.preventDefault();
    e.stopPropagation();
    didDrag.current = false;
    const rect = elementRef.current?.getBoundingClientRect();
    if (rect) {
      dragOffset.current = {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      };
      if (!position) {
        const parentRect = elementRef.current.offsetParent?.getBoundingClientRect() || { left: 0, top: 0 };
        setPosition({
          x: rect.left - parentRect.left,
          y: rect.top - parentRect.top,
        });
      }
    }
    setIsDragging(true);
  }, [position]);

  const handleMouseMove = useCallback((e) => {
    if (!isDragging || !elementRef.current) return;
    didDrag.current = true;
    const parentRect = elementRef.current.offsetParent?.getBoundingClientRect() || { left: 0, top: 0 };
    setPosition({
      x: e.clientX - parentRect.left - dragOffset.current.x,
      y: e.clientY - parentRect.top - dragOffset.current.y,
    });
  }, [isDragging]);

  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, []);

  useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging, handleMouseMove, handleMouseUp]);

  const handleClick = (e) => {
    if (didDrag.current) return;
    if (onClick) onClick(e);
  };

  const positionStyle = position
    ? { position: "absolute", left: position.x, top: position.y }
    : {};

  return (
    <div
      ref={elementRef}
      className={`flex flex-col items-center gap-1 cursor-pointer select-none ${isDragging ? "cursor-grabbing z-50" : ""} ${className}`}
      style={{
        ...style,
        ...positionStyle,
        width: "min-content",
      }}
      onMouseDown={handleMouseDown}
      onClick={handleClick}
      draggable={false}
    >
      <div className="w-[59px] h-[59px] relative flex items-center justify-center">
        {/* Document / generic icon */}
        <img src={src} alt="" />
      </div>
      <div className="w-[85px] h-4 relative overflow-visible">
        <p
          className="absolute top-1/2 left-0 right-0 -translate-y-1/2 text-center break-words text-[13.5px]"
          style={{
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif',
            fontWeight: 500,
            color: "#000",
          }}
        >
          {name}
        </p>
      </div>
    </div>
  );
}
